import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Card } from '@mui/material';
import { Upload } from 'antd';
import { AiOutlinePlus } from 'react-icons/ai';
import { FiEdit } from 'react-icons/fi';
import { useDispatch, useSelector } from 'react-redux';
import styles from './MyProfile.module.css';
import { isEmpty, storeUser } from '../../Services/config/globals';
import { uploadImages } from '../../Services/Utils/CommonApis';
import { changeUserLogo } from '../../Services/Utils/UserApis';
import { getImage } from '../../Services/Utils/FileApis';
import { notifySet, userSet } from '../../Services/Actions/CommonActions';
import withUser from '../../common/withUser';
import { viewStartUp } from '../../Services/Utils/StartupApis';
import ButtonMailTo from '../../components/ButtonMailTo';

function MyProfile() {
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const [cloudDeals, setCloudDeals] = useState([]);
  const [imageUrl, setImageUrl] = useState();

  const uploadButton = (
    <div>
      <div style={{ marginTop: 8 }}><AiOutlinePlus /></div>
    </div>
  );

  const handleChange = (imageData) => {
    uploadImages({ file: imageData.file }).then((res) => {
      if ( res.hasError === false ) {
        const reader = new FileReader();
        reader.readAsDataURL(imageData.file);
        reader.onload = (e) => {
          setImageUrl(e.target.result);
        };
        changeUserLogo({ fileId: res.view.fileId }).then((resp) => {
          if (resp.hasError === false) {
            user.view = resp.view;
            storeUser(user);
            dispatch(userSet(user));
            dispatch(notifySet({ type: 'success', message: resp.message }));
          } else {
            dispatch(notifySet({ type: 'error', message: resp.message }));
          }
        });
      } else if (res.hasError === true) {
        dispatch(notifySet({ type: 'error', message: res.message }));
      }
    });
  };
  useEffect(()   => {
    viewStartUp({ id: user.view.id }).then((response) => {
      const { view } = response;
      setCloudDeals(view.availableDeals);
      user.view.eventView = view.eventView;
      user.view.unreadCount = view.unreadCount;
      storeUser(user);
    });
    if (user.view.hasOwnProperty('logoView')) {
      setImageUrl(getImage(user.view?.logoView));
    }
  }, []);

  return (
    <div className="row">
      <div className="col-sm-12">
        <div className="product-detail-con">
          <Card className="product-detail-card">
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-7 col-xl-8 col-xxl-9">
                <div className="pro-image-link-box-con pro-image-link-box-big">
                  <div className="pro-image-link-box-img">
                    <Upload
                      name="avatar"
                      listType="picture-card"
                      className="avatar-uploader"
                      accept="image/*"
                      showUploadList={false}
                      beforeUpload={() => false}
                      onChange={handleChange}
                    >
                      <div className="edit-profile-pic-icon">
                        <FiEdit className="icon-position" />
                      </div>
                      <div style={{ position: 'relative' }}>
                        {imageUrl ? (<img src={imageUrl} alt="avatar" style={{ width: '100%', minWidth: '60px' }} />) : (uploadButton)}
                      </div>
                    </Upload>
                  </div>
                  <div className="pro-image-link-box-text left-broder-line">
                    <h4>{user.view.name}</h4>
                    <div className={`${styles['info-list-ul']}`}>
                      <ul>
                        <li>
                          <strong>Registered Name</strong> : {user.view.registeredName}
                        </li>
                        <li>
                          <strong>Founder Name</strong> : {user.view.founderName}
                        </li>
                        <li>
                          <strong>Contact No</strong> : +91 {user.view.mobile}
                        </li>
                        <li>
                          <strong>Email ID</strong> : {user.view.email}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-12 col-lg-5 col-xl-4 col-xxl-3">
                <div className="left-broder-line">
                  {user.view.pocName || user.view.pocEmail ? <h6 title="Portfolio Manager Details">CIIE.CO PM Details</h6> : ''}
                  <div className="icon-list-ul">
                    <ul>
                      <li>
                        <Link
                          className="icon-list-ul-full"
                          to="#"
                        >
                          <span className="icon-list-ul-img">
                            <img
                              alt=""
                              src="/assets/images/user-icon.svg"
                            />
                          </span>
                          <span className="icon-list-ul-text">{user.view.pocName}</span>
                        </Link>
                      </li>
                      <li>
                        <ButtonMailTo
                          className="icon-list-ul-full"
                          link={`mailto:${user.view.pocEmail}`}
                        >
                          <span className="icon-list-ul-img">
                            <img
                              alt=""
                              src="/assets/images/mail-icon.svg"
                            />
                          </span>
                          <span className="icon-list-ul-text">{user.view.pocEmail}</span>
                        </ButtonMailTo>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>
      {!isEmpty(cloudDeals) && (
        <div className="col-sm-12">
          <div className="product-detail-con">
            <Card className="product-detail-card">
              <div className={`${styles['tag-btn-title-list-con']}`}>
                <div className="row">
                  <div className="col-sm-12">
                    <h5>Availed Deals</h5>
                    {Object.keys(cloudDeals).map((category, key) => (
                      <div
                        key={key}
                        className={`${styles['tag-btn-title-list-col']} ${styles.smaller}`}
                      >
                        <div className="row">
                          <div className="col-sm-12 col-md-3 col-lg-3">
                            <div className={`${styles['tag-btn-title-list-title']}`}>
                              <h6 className="sm-tag-font">{category}</h6>
                            </div>
                          </div>
                          <div className="col-sm-12 col-md-9 col-lg-9">
                            <div className="tag-btn-title-list-tag">
                              <div className={`${styles['tag-btn-menu-ul-con']}`}>
                                <ul>
                                  {cloudDeals[category].map((deals, Categorykey) => (
                                    <li key={Categorykey}>
                                      <Link
                                        to={`/service-provider/${deals.categoryView.id}/${deals.id}`}
                                        key={deals.id}
                                      >
                                        {deals.name}
                                      </Link>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </Card>
          </div>
        </div>
      )}
    </div>
  );
}

export default withUser(MyProfile);
